import endpoint from "../../config/endpoints";

export const StockTransferJson = {
  showSaveNextBtn: true,
  formPath: "/stock-transfer-form",
  apiBaseURL: endpoint.stockTransferInOutHeader,
  changeExcel: endpoint.exportData,
  screenTitle: "Stock Transfer",
  showAddButton: true,
  formPathView: "/stock-transfer-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Date",
      columnKeyName: "date",
      isChecked: true,
    },
    {
      columnDisplayName: "Transfer No",
      columnKeyName: "transferNo",
      isChecked: true,
    },
    {
      columnDisplayName: "Stock Holder Name",
      columnKeyName: "stockStakeHolderName",
      isChecked: true,
    },
    {
      columnDisplayName: "From Transfer",
      columnKeyName: "fromTransferHolderName",
      isChecked: true,
    },
    {
      columnDisplayName: "To Transfer",
      columnKeyName: "toTransferHolderName",
      isChecked: true,
    },
    {
      columnDisplayName: "Transaction",
      columnKeyName: "transaction",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "statusForTable",
      isChecked: true,
    },
  ],

  searchListForAdmin: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
      isMandatory: true,
      onSubmit: "compare",
    },
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "region,state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "region,state,zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "region,state,zone,district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "region,state,zone,district,taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Stock Holder",
      controlType: "multiSelect",
      placeHolder: "Select Stock Holder",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderDetail",
      dataKey: "stockHolder",
      getListFrom: "region,state,zone,district,taluka,area",
      getListId: "stockHolder",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Driver",
      controlType: "multiSelect",
      placeHolder: "Select Driver",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "driverDetail",
      dataKey: "driver",
      getListFrom: "region,state,zone,district,taluka,area,stockHolder",
      getListId: "driver",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMeta: [
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "region,state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "region,state,zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "region,state,zone,district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "region,state,zone,district,taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Stock Holder",
      controlType: "autocomplete",
      placeHolder: "Select Stock Holder",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderDetail",
      dataKey: "stockHolder",
      getListFrom: "region,state,zone,district,taluka,area",
      getListId: "stockHolder",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Driver",
      controlType: "autocomplete",
      placeHolder: "Select Driver",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "driverDetail",
      dataKey: "driver",
      getListFrom: "region,state,zone,district,taluka,area,stockHolder",
      getListId: "driver",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForStockHolder: [
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Driver",
      controlType: "autocomplete",
      placeHolder: "Select Driver",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "driverDetail",
      dataKey: "driver",
      getListFrom: "area",
      getListId: "driver",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  searchListForStockHolder: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
      isMandatory: true,
      onSubmit: "compare",
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "area",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },

    {
      label: "Driver",
      controlType: "multiSelect",
      placeHolder: "Select Driver",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "driverDetail",
      dataKey: "driver",
      getListFrom: "area",
      getListId: "driver",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
